import { RESET_STATE } from 'store/global/actions';

import { CALENDAR_EVENTS_ACTION_TYPE } from '../actions';

const initialState = [];

const calendarEventsSummaryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CALENDAR_EVENTS_ACTION_TYPE.GET_CALENDAR_EVENTS_SUMMARY:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default calendarEventsSummaryReducer;
